/* integration_v2 */
const config = {
    logLevel: "trace",
    baseHref: "/",
    title: "widgets",
}
export default config
